import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, watch } from "vue";
import { StatusClassNames } from "../types/StatusClassNames";
import { onTransitionEnd } from "../utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TextPreloader',
    props: {
        active: { type: Boolean, default: true },
    },
    setup(__props) {
        const props = __props;
        const show = ref(props.active);
        const isActive = ref(props.active);
        const el = ref();
        watch(() => props.active, (value) => {
            if (value) {
                show.value = true;
                setTimeout(() => isActive.value = true, 20);
            }
            else {
                isActive.value = false;
                onTransitionEnd(el.value, () => show.value = false, 'opacity');
            }
        });
        return (_ctx, _cache) => {
            return (show.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["text-preloader", { [_unref(StatusClassNames).active]: isActive.value }]),
                    ref_key: "el",
                    ref: el
                }, null, 2 /* CLASS */))
                : _createCommentVNode("v-if", true);
        };
    }
});
